import * as React from 'react'
import { useCallback, useState } from 'react'
import { FullScreenDialog } from '@user/components/FullScreenDialog'
import { SettingsPage, Tab, TabPanel } from '@sales-center/components'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import { useTheme } from '@mui/material/styles'
import {
  ILocationSearchModel,
  LocationSearchResponse,
} from '@user/query/useLocationSearch'
import { DuplicateCheckResponse } from '@user/query/useDuplicateCheck'
import { WorkWaveContactsDuplicates } from '@user/components/Leads/AddLeadPage/FormComponents/DuplicateAlert/DuplicateDialog/WorkwaveContacts'
import { PestPacLocationDuplicates } from '@user/components/Leads/AddLeadPage/FormComponents/DuplicateAlert/DuplicateDialog/PestPacLocations'
import { useAppDispatch } from '@user/store/hooks'
import { setSearch } from '@user/store/duplicates/WorkwaveContacts/slice'

export interface DuplicateDialogProps {
  open: boolean
  onClose: () => void
  branchListLoadStatus: 'success' | 'pending' | 'fail'
  internalResponse: DuplicateCheckResponse
  externalResponse: LocationSearchResponse
  searchTermObj: Record<string, string>
  searchTermArr: string[]
  createOppCallback: (location: ILocationSearchModel) => void
  handleDuplicateManageClick?: () => void
}

export const DuplicateDialog = ({
  open,
  onClose,
  internalResponse,
  externalResponse,
  searchTermObj,
  createOppCallback,
  handleDuplicateManageClick,
}: DuplicateDialogProps) => {
  const theme = useTheme()
  const [tab, setTab] = useState(2)
  const internalCount = internalResponse.resultCount
  const externalCount = externalResponse.resultCount

  const dispatch = useAppDispatch()
  const onChangeTab = useCallback(
    (_e: React.ChangeEvent<unknown>, value: number) => setTab(value),
    [],
  )

  const onDialogClose = useCallback(() => {
    setTab(2)
    dispatch(setSearch(''))
    onClose()
  }, [dispatch, onClose])

  return (
    <FullScreenDialog
      open={open}
      onClose={onDialogClose}
      closeButtonText="Close"
    >
      <SettingsPage
        title="Duplicate Alert"
        padding="0"
        fullScreen
        headerBgColor={'white'}
        bgColor={'#F9FAFB'}
        hideDivider
      >
        <AppBar
          color="default"
          elevation={1}
          position="sticky"
          sx={{
            backgroundColor: theme.palette.common.white,
            paddingLeft: 2,
            marginBottom: '10px',
          }}
        >
          <Tabs value={tab} onChange={onChangeTab}>
            <Tab
              value={2}
              label={`PestPac Locations (${externalCount})`}
              sx={{ padding: theme.spacing(0, 2), whiteSpace: 'nowrap' }}
              data-test-id="pestpac-locations-tab"
            />
            <Tab
              value={1}
              label={`Existing Leads/Opps (${internalCount})`}
              sx={{ padding: theme.spacing(0, 2), whiteSpace: 'nowrap' }}
              data-test-id="workwave-marketing-contacts-tab"
            />
          </Tabs>
        </AppBar>
        <TabPanel tab={tab} value={1}>
          <WorkWaveContactsDuplicates
            highlights={searchTermObj}
            handleDuplicateManageClick={handleDuplicateManageClick}
            onDialogClose={onDialogClose}
            loading={internalResponse.loading}
          />
        </TabPanel>
        <TabPanel tab={tab} value={2}>
          <PestPacLocationDuplicates
            highlights={searchTermObj}
            createOppCallback={createOppCallback}
            handleDuplicateManageClick={handleDuplicateManageClick}
            loading={externalResponse.loading}
          />
        </TabPanel>
      </SettingsPage>
    </FullScreenDialog>
  )
}
